export class ImageDto {
  [key: string]: any;
  constructor(
    public imageId: string,
    public imageUrl: string,
    public archivesImageId?: string,
    public imageAngle?: string,
    public imageDescription?: string,
    public photographerName?: string,
    public imageCaption?: string
  ) {
  }
}
